// @flow

import axios from 'axios';
import * as React from 'react';
import * as Redux from 'redux';
import _ from 'lodash';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import TextInput from './../../../../../components/TextInput';
import SelectInput from './../../../../../components/SelectInput';
import DefaultButton from './../../../../../components/DefaultButton';
import { setLabelsConfig } from './../../../../../actions/map';

type State = {
    selectedLayerName: string,
    dictionaries: array<object>,
    text: string,
    maxreso: string,
    align: string,
    rotation: string,
    size: string,
    offsetX: string,
    offsetY: string,
    vectorLayers: array<object>,
    selectedLayerFields: array<object>,
    selectedLayerName: string,
    selectedField: string,
};
type Props = {
};

const SettingsWrapper = styled.div`
    max-width: calc(100% - 20px);
    width: 100%;
    flex-shrink: 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
`;

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`

const SetProjectInfo = styled.div`
    color: red;
    font-size: 14px;
`

class LabelSettings extends React.Component<Props, State> {
    defaultConfig = {
        layerName: '',
        values: {
            text: 'normal',
            maxreso: '7',
            align: 'center',
            baseline: 'middle',
            rotation: '0',
            font: 'arial',
            weight: 'normal',
            size: '12px',
            offsetX: '0',
            offsetY: '15',
            color: '#000000',
            outline: '#ffffff',
            outlineWidth: '2',
            placement: 'point',
            attribute: '',
        },
    };

    constructor(props) {
        super();
        const { t, layers } = props;
        const vectorLayers = layers
            ? layers
                .getArray()
                .filter(layer => layer.values_.type === 1 && layer.get('groupName'))
                .concat([{ values_: { name: t('Select layer') } }])
            : [{ values_: { name: t('Select layer') } }];

        const selectedLayerFields = [{ name: t('Select field') }];

        const {
            text,
            maxreso,
            align,
            rotation,
            size,
            offsetX,
            offsetY,
        } = this.defaultConfig.values;

        this.state = {
            vectorLayers: vectorLayers,
            selectedLayerName: t('Select layer'),
            selectedLayerFields: selectedLayerFields,
            text: text,
            maxreso: maxreso,
            align: align,
            rotation: rotation,
            size: size.slice(0, -2),
            offsetX: offsetX,
            offsetY: offsetY,
            selectedField: selectedLayerFields[0],
            dictionaries: {
                text: [
                    {
                        value: 'normal',
                        label: t('normal'),
                    },
                    {
                        value: 'shorten',
                        label: t('shorten'),
                    },
                    {
                        value: 'wrap',
                        label: t('wrap'),
                    },
                ],
                maxreso: [
                    {
                        value: '7',
                        label: '7',
                    },
                    {
                        value: '8',
                        label: '8',
                    },
                    {
                        value: '9',
                        label: '9',
                    },
                ],
                align: [
                    {
                        value: 'center',
                        label: t('center'),
                    },
                    {
                        value: 'left',
                        label: t('left'),
                    },
                    {
                        value: 'right',
                        label: t('right'),
                    },
                ],
                rotation: [
                    {
                        value: '0',
                        label: '0',
                    },
                    {
                        value: '0.785398164',
                        label: '45',
                    },
                    {
                        value: '1.570796327',
                        label: '90',
                    },
                ],
            }
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { t, layers } = nextProps;

        if (prevState.vectorLayers[0].values_.name === t('Select layer') && layers) {
            return ({
                vectorLayers: layers
                    .getArray()
                    .filter(layer => layer.values_type === 1)
                    .concat([{ values_: { name: t('Select layer') } }]),
                selectedLayerName: t('Select layer'),
            })
        }
        return prevState;
    }

    componentDidUpdate(prevProps, prevState) {
        const { t } = this.props;
        const { selectedLayerName, vectorLayers, selectedField } = this.state;
        if (prevState.selectedLayerName !== selectedLayerName
            && selectedLayerName !== ''
            && selectedLayerName !== t('Select layer')) {

            const selectedLayer = vectorLayers.find(layer => layer.values_.name === selectedLayerName)           
            axios.get(selectedLayer.values_.describeUrl)
                .then((response) => {
                    const fields = response.data.featureTypes[0].properties
                        .filter(p => p.name !== 'the_geom')
                        .map(p => {return { "name": p.name, "value": p.name }});
                    
                    const hasSelectedField = selectedField !== t('Select field')
                    this.setState({
                        selectedLayerFields: [{ name: t('Select field') }].concat(fields),
                        selectedField: hasSelectedField ? selectedField : t('Select field'),
                    });
                })
                .catch((error) => {
                    console.log(error);
                })        
        }
    }

    saveLabelsConfig = config => {
        const configString = JSON.stringify(config)
        localStorage.setItem('labelsConfig', configString);
    }

    setLabel() {
        const { setLabelsConfig } = this.props;
        const {
            selectedLayerName,
            selectedField,
            text,
            maxreso,
            align,
            rotation,
            size,
            offsetX,
            offsetY,
        } = this.state;
        const config = _.cloneDeep(this.defaultConfig);
        config.layerName = selectedLayerName;
        config.values.attribute = selectedField;
        config.values.text = text;
        config.values.maxreso = maxreso;
        config.values.align = align;
        config.values.rotation = rotation;
        config.values.size = size + 'px';
        config.values.offsetX = offsetX;
        config.values.offsetY = offsetY;
        setLabelsConfig([config])
        this.saveLabelsConfig(config)
    }

    clearLabel() {
        const { t, setLabelsConfig } = this.props;
        const { dictionaries } = this.state;
        const config = _.cloneDeep(this.defaultConfig);
        config.values.text = 'hide';
        setLabelsConfig([config])
        this.saveLabelsConfig(config)
        this.setState({
            selectedLayerName: t('Select layer'),
            selectedField: t('Select field'),
            text: dictionaries.text[0].value,
            maxreso: dictionaries.maxreso[0].value,
            align: dictionaries.align[0].value,
            rotation: dictionaries.rotation[0].value,
            size: '12',
            offsetX: '0',
            offsetY: '15',
        })
    }

    //TODO: zbyt szybkie przełączenia na zakładkę powoduje wywalenie aplikacji
    //TODO: przenieść do ładowania aplikacji
    // componentDidMount() {
        // this.loadLabelConfigHandler();
    // }

    render(): React.Node {
        const {
            selectedLayerName,
            vectorLayers,
            selectedField,
            selectedLayerFields,
            dictionaries,
            text,
            maxreso,
            align,
            rotation,
            size,
            offsetX,
            offsetY,
        } = this.state;
        const { t, chosenFlight } = this.props;

        return (
            <SettingsWrapper>
                {!chosenFlight && 
                    <SetProjectInfo>{t('No mission selected please select for create label')}</SetProjectInfo>
                }
                <InputWrapper>
                    <span>
                        {t('Layer')}
                    </span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={selectedLayerName}
                        onChange={(e) => { this.setState({ selectedLayerName: e.target.value }) }}>
                        {vectorLayers.map(layer => {
                            return (
                                <option
                                    key={`label_layer_${layer.values_.name}`}
                                    value={layer.values_.name}>
                                    {t(layer.values_.name)}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>
                        {t('Attribute')}
                    </span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={selectedField}
                        onChange={(e) => { this.setState({ selectedField: e.target.value }) }}>
                        {selectedLayerFields.map(field => {
                            return (
                                <option
                                    key={`label_field_${field.name}`}
                                    value={field.name}>
                                    {field.name}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Style')}</span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={text}
                        onChange={(e) => { this.setState({ text: e.target.value }) }}>
                        {dictionaries.text.map(row => {
                            return (
                                <option
                                    key={`${row.value}_label_input`}
                                    value={row.value}>
                                    {row.label}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Min zoom')}</span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={maxreso}
                        onChange={(e) => { this.setState({ maxreso: e.target.value }) }}>
                        {dictionaries.maxreso.map(row => {
                            return (
                                <option
                                    key={`${row.value}_label_input`}
                                    value={row.value}>
                                    {row.label}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Align')}</span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={align}
                        onChange={(e) => { this.setState({ align: e.target.value }) }}>
                        {dictionaries.align.map(row => {
                            return (
                                <option
                                    key={`${row.value}_label_input`}
                                    value={row.value}>
                                    {row.label}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Rotation')}</span>
                    <SelectInput
                        style={{
                            minWidth: '130px',
                            margin: '2px',
                        }}
                        value={rotation}
                        onChange={(e) => { this.setState({ rotation: e.target.value }) }}>
                        {dictionaries.rotation.map(row => {
                            return (
                                <option
                                    key={`${row.value}_label_input`}
                                    value={row.value}>
                                    {row.label}
                                </option>
                            )
                        })}
                    </SelectInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Size')}</span>
                    <TextInput
                        style={{
                            margin: '2px',
                            width: '114px',
                            marginRight: '10px',
                        }}
                        type='text'
                        value={size}
                        placeholder={t('Size')}
                        onChange={(e) => { this.setState({ size: e.target.value }) }}>
                    </TextInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Offset')} X</span>
                    <TextInput
                        style={{
                            margin: '2px',
                            width: '114px',
                            marginRight: '10px',
                        }}
                        type='text'
                        value={offsetX}
                        placeholder={`${t('Offset')} X`}
                        onChange={(e) => { this.setState({ offsetX: e.target.value }) }}>
                    </TextInput>
                </InputWrapper>

                <InputWrapper>
                    <span>{t('Offset')} Y</span>
                    <TextInput
                        style={{
                            margin: '2px',
                            width: '114px',
                            marginRight: '10px',
                        }}
                        type='text'
                        value={offsetY}
                        placeholder={`${t('Offset')} Y`}
                        onChange={(e) => { this.setState({ offsetY: e.target.value }) }}>
                    </TextInput>
                </InputWrapper>


                <DefaultButton
                    style={{
                        width: '150px',
                        margin: '2px',
                    }}
                    disabled={selectedLayerName === t('Select layer') || selectedField === t('Select field')}
                    onClick={() => {
                        this.setLabel()
                    }}>
                    {t('Set label')}
                </DefaultButton>
                <DefaultButton
                    style={{
                        width: '150px',
                        margin: '2px',
                    }}
                    onClick={() => {
                        this.clearLabel()
                    }}>
                    {t('Clear label')}
                </DefaultButton>
            </SettingsWrapper>
        );
    }
}

const mapStateToProps: MapStateToProps<*, *, *> = state => ({
    layers: state.mapData.get('olLayers'),
    labelsConfig: state.mapData.get('labelsConfig'),
    chosenFlight: state.flightManager.get('chosenFlight')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setLabelsConfig,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(LabelSettings));



// WEBPACK FOOTER //
// ./src/containers/content/grid/userWrapper/labelSettings/LabelSettings.jsx